import { Component } from '@angular/core';
import { AppService } from 'src/@core/services/app.service';

/**
 * My Leads: the leads assigned to the signed-in user through outcome
 * assign_users, across every project.
 */
@Component({
  selector: 'hour4u-admin-my-leads',
  templateUrl: './my-leads.component.html',
  styleUrls: ['./my-leads.component.scss']
})
export class MyLeadsComponent {
  profile = this.appService.getCurrentAccount();

  constructor(private appService: AppService) { }

  get userId(): string | null {
    return (this.profile && this.profile.user && this.profile.user.id) || null;
  }
}
